module.exports = __webpack_public_path__ + "img/banner.771e7868.jpg";